import { XMarkIcon } from "@heroicons/react/24/solid"
import React from "react"

interface ModalCloseButtonProps {
  onClick: () => void
  className?: string
  "data-testid"?: string
}

// Sized in raw px, not rem, on purpose: index.css scales the root font size
// down to 50% below 1000px wide, so a rem-based `w-10 h-10` collapsed to a 20px
// target on a phone. px keeps the button at a thumb-sized 44px there.
const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClick,
  className,
  "data-testid": testId,
}) => {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`relative w-[44px] h-[44px] md:w-[48px] md:h-[48px] shrink-0 rounded-full flex items-center justify-center group
        focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-offset-2 focus:ring-offset-black/50 ${className || ""}`}
    >
      <div
        className="absolute inset-0 rounded-full flex items-center justify-center overflow-hidden transition-all duration-200 ease-out
          bg-gradient-to-br from-red-500 via-red-600 to-red-700
          border-2 border-red-400/50
          shadow-lg shadow-red-500/30
          group-hover:scale-110 group-hover:shadow-xl group-hover:shadow-red-500/50 group-hover:brightness-110
          group-active:scale-90 group-active:brightness-90 group-active:shadow-inner
          before:absolute before:inset-0 before:rounded-full before:bg-white/0 before:transition-all before:duration-300
          group-active:before:bg-white/30 group-active:before:scale-150"
      >
        <XMarkIcon className="h-[24px] w-[24px] md:h-[26px] md:w-[26px] text-white relative z-10 transition-transform duration-200 group-hover:rotate-90" />
      </div>
    </button>
  )
}

export default ModalCloseButton
